import { IKnmStatusSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmStatusSelectOption';
import { KnmErknmStatusCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';

import { PublishRulesCategoriesEnum } from '../enums/publishRulesCategoriesEnum';
import { PublishRulesDeadlineModesEnum } from '../enums/publishRulesDeadlineModesEnum';
import { PublishRulesKnmUnscheduledFormBlockNamesEnum } from '../enums/publishRulesKnmUnscheduledFormBlockNamesEnum';
import { IPublishRulesKnmUnscheduledForm } from '../interfaces/IPublishRulesKnmUnscheduledForm';
import { IPublishRulesTreeItem } from '../interfaces/IPublishRulesTreeItem';
import { getPublishDeadlineOptions } from './getPublishDeadlineOptions';

export const getPublishRulesKnmUnscheduledFormInitialValues: (
  treeItem: IPublishRulesTreeItem,
  knmStatusesSelectOptions?: IKnmStatusSelectOption[],
) => IPublishRulesKnmUnscheduledForm = (treeItem, knmStatusesSelectOptions) => {
  const publishDeadlineImmediatelyOption = getPublishDeadlineOptions().find(
    item => item.value === PublishRulesDeadlineModesEnum.IMMEDIATELY,
  );

  const completedKnmStatusOption = knmStatusesSelectOptions?.find(
    item => item.value === KnmErknmStatusCodesEnum.TYPE_COMPLETED,
  );

  const waitingCarryOutKnmStatusOption = knmStatusesSelectOptions?.find(
    item => item.value === KnmErknmStatusCodesEnum.TYPE_WAITING_CARRY_OUT,
  );

  const cantBeCarryOutKnmStatusOption = knmStatusesSelectOptions?.find(
    item => item.value === KnmErknmStatusCodesEnum.TYPE_CANT_BE_CARRY_OUT,
  );

  const categoriesFirstGroupStatuses = waitingCarryOutKnmStatusOption ? [waitingCarryOutKnmStatusOption] : undefined;

  const categoriesSecondGroupStatuses =
    completedKnmStatusOption && cantBeCarryOutKnmStatusOption
      ? [completedKnmStatusOption, cantBeCarryOutKnmStatusOption]
      : undefined;

  switch (treeItem.category) {
    case PublishRulesCategoriesEnum.UNPLANNED_KNM_KZ:
    case PublishRulesCategoriesEnum.UNPLANNED_KNM_RO:
    case PublishRulesCategoriesEnum.UNPLANNED_KNM_VK:
    case PublishRulesCategoriesEnum.UNPLANNED_KNM_IV:
    case PublishRulesCategoriesEnum.UNPLANNED_KNM_MZ:
      return {
        [PublishRulesKnmUnscheduledFormBlockNamesEnum.PROMPTLY]: {
          uponAttainingStatus: categoriesSecondGroupStatuses,
          publishDeadline: publishDeadlineImmediatelyOption,
          additionalSettings: [],
        },
        [PublishRulesKnmUnscheduledFormBlockNamesEnum.NON_REQUIRED]: {
          uponAttainingStatus: categoriesSecondGroupStatuses,
          publishDeadline: publishDeadlineImmediatelyOption,
          additionalSettings: [],
        },
        [PublishRulesKnmUnscheduledFormBlockNamesEnum.REQUIRED]: {
          uponAttainingStatus: categoriesSecondGroupStatuses,
          publishDeadline: publishDeadlineImmediatelyOption,
          additionalSettings: [],
        },
      };
    case PublishRulesCategoriesEnum.UNPLANNED_KNM:
    case PublishRulesCategoriesEnum.UNPLANNED_KNM_DP:
    case PublishRulesCategoriesEnum.UNPLANNED_KNM_VP:
      return {
        [PublishRulesKnmUnscheduledFormBlockNamesEnum.PROMPTLY]: {
          uponAttainingStatus: categoriesFirstGroupStatuses,
          publishDeadline: publishDeadlineImmediatelyOption,
          additionalSettings: [],
        },
        [PublishRulesKnmUnscheduledFormBlockNamesEnum.NON_REQUIRED]: {
          uponAttainingStatus: categoriesFirstGroupStatuses,
          publishDeadline: publishDeadlineImmediatelyOption,
          additionalSettings: [],
        },
        [PublishRulesKnmUnscheduledFormBlockNamesEnum.REQUIRED]: {
          uponAttainingStatus: categoriesFirstGroupStatuses,
          publishDeadline: publishDeadlineImmediatelyOption,
          additionalSettings: [],
        },
      };
    default:
      return {
        [PublishRulesKnmUnscheduledFormBlockNamesEnum.PROMPTLY]: {
          uponAttainingStatus: undefined,
          publishDeadline: undefined,
          additionalSettings: [],
        },
        [PublishRulesKnmUnscheduledFormBlockNamesEnum.NON_REQUIRED]: {
          uponAttainingStatus: undefined,
          publishDeadline: undefined,
          additionalSettings: [],
        },
        [PublishRulesKnmUnscheduledFormBlockNamesEnum.REQUIRED]: {
          uponAttainingStatus: undefined,
          publishDeadline: undefined,
          additionalSettings: [],
        },
      };
  }
};
